import * as env from '@owl-nest/config'
import { initializeLocalization } from '@owl-nest/localize'

/**
 * Client bootstrap shared by the standalone static About pages — mirrors the legacy MPA `init()`
 * pattern (see e.g. features/newsletter/src/index.tsx), sourced standalone.
 *
 * Env resolves from Vite `define`-inlined `process.env` (EXPOSED_ENV_VARIABLES) + cookies — the
 * same way `ulule-next` resolves it, with `window.UFE` simply absent — plus `getUfeConfig()`
 * (`/ufe/config/`) for dynamic bits, and `useAuth` (token cookies) for login state. There is NO
 * Django `base_wrapper` and NO `window.UFE` injection here.
 *
 * SITE-WIDE CONCERNS NOT INHERITED (dropped `base_wrapper` on purpose to keep new About pages
 * lightweight and legacy-free). Decide later, per item, whether to port or drop:
 *   - GTM / analytics (`@owl-nest/shadow` TrackingProvider)
 *   - consent / cookie banner
 *   - old-browser banner
 *   - global toasts / notifications
 *   - base/global CSS + resets beyond the shared `_shared/base.css`
 *   - default meta
 *   - server-driven i18n (these pages ship French-only for v1)
 */
export async function bootstrap() {
  await env.initUserConfig()
  const userConfig = await env.getUserConfig()

  await initializeLocalization(userConfig.lang, env.LOCALE_FILES[userConfig.lang])

  return userConfig
}
